export enum AffiliateCode {
    // Octopus Energy (Onboarding Direct)
    OCTOFLEX = "octoflex",
    OCTOPUS_DIRECT = "octopus-direct",
    OCTOPUS_DIRECT_LOW_PRICE = "octopus-direct-low-price",
    OCTOPUS_DIRECT_LOW_COMPLEXITY = "octopus-direct-low-complexity",
    // Onboarding Direct + Switch Product
    INTELLIGENT_OCTOPUS = "intelligent-octopus",
    OCTOPUS_GO = "octopus-go",
    // Switch Product
    ECO_CONSO_INDEXEE = "eco-conso-indexee",
    ECO_CONSO_FIXE_2_YEARS = "eco-conso-fixe-2-ans",
    ECO_CONSO_FIXE_3_YEARS = "eco-conso-fixe-3-ans",
    ECO_CONSO_FIXE_3_YEARS_V2 = "eco-conso-fixe-3-ans-v2",
    ECO_CONSO_FIXE_2_AND_3_YEARS = "eco-conso-fixe-2-et-3-ans",
    ECO_CONSO_FIXE_3ANS_DTD_JUILLET26 = "eco-conso-fixe-3-ans-dtd-juillet26",
    EMCE_2_AND_3_YEARS = "emce-2-et-3-ans",
    OFFRE_SAISONNALISEE = "offre-saisonnalisee",
    SEPT_26_ROLLOVER = "sept-26-rollover",
    // Rollover
    ROLLOVER = "rollover",

    // Ford (Onboarding Direct + Switch Product)
    FORD_1_YEAR = "ford-intelligent-octopus-1-an",
    FORD_3_YEARS = "ford-intelligent-octopus-3-ans",

    // Enki (Onboarding Direct)
    ENKI_INTELLIGENT_OCTOPUS = "enki-intelligent-octopus",
    ENKI_OCTOPUS_GO = "enki-octopus-go",

    // Renault (Onboarding Direct)
    RENAULT_INTELLIGENT_OCTOPUS = "offre-speciale-renault",

    ACHETONS_GROUPE_NOV = "achetonsgroupenov",

    // Effy (Telesales)
    OFFRE_EFFY = "offre-effy",
}

export const DirectAffiliateCodes = [
    AffiliateCode.OCTOPUS_DIRECT,
    AffiliateCode.OCTOPUS_DIRECT_LOW_COMPLEXITY,
    AffiliateCode.OCTOPUS_DIRECT_LOW_PRICE,
]

const OctopusGoAffiliateCodes: AffiliateCode[] = [
    AffiliateCode.OCTOPUS_GO,
    AffiliateCode.ENKI_OCTOPUS_GO,
]

export const IntelligentOctopusAffiliateCodes: AffiliateCode[] = [
    AffiliateCode.FORD_1_YEAR,
    AffiliateCode.FORD_3_YEARS,
    AffiliateCode.INTELLIGENT_OCTOPUS,
    AffiliateCode.ENKI_INTELLIGENT_OCTOPUS,
]

export const ElectricVehicleAffiliateCodes: AffiliateCode[] = [
    ...OctopusGoAffiliateCodes,
    ...IntelligentOctopusAffiliateCodes,
]

export const ServiceLevel2AffiliateCodes: AffiliateCode[] = [
    ...IntelligentOctopusAffiliateCodes,
    AffiliateCode.OCTOFLEX,
]
